import { useEffect, useState } from "react";
import { getPageDefaults } from "@/config/pageContentConfig";

/**
 * Fetches editable page content from the database.
 * Dynamically imports the Supabase client so it stays out of the initial bundle.
 * Returns a `t(sectionKey, fieldKey)` helper that returns the DB value or the default.
 */
export function usePageContent(pageSlug: string) {
  const [overrides, setOverrides] = useState<Record<string, string>>({});
  const [loading, setLoading] = useState(true);
  const defaults = getPageDefaults(pageSlug);

  useEffect(() => {
    import("@/integrations/supabase/client").then(({ supabase }) =>
      supabase
        .from("page_content")
        .select("section_key, field_key, field_value")
        .eq("page_slug", pageSlug)
        .then(({ data }) => {
          if (data) {
            const map: Record<string, string> = {};
            for (const row of data) {
              map[`${row.section_key}.${row.field_key}`] = row.field_value;
            }
            setOverrides(map);
          }
          setLoading(false);
        })
    );
  }, [pageSlug]);

  const t = (sectionKey: string, fieldKey: string): string => {
    const key = `${sectionKey}.${fieldKey}`;
    return overrides[key] ?? defaults[key] ?? "";
  };

  return { t, loading };
}
